import React, { useState } from "react";
import asideMapping from "../../utility/aside";
import DataTable from 'react-data-table-component';
import LoaderIndex from "~/containers/LoaderIndex";
import { ResponsiveBar } from '@nivo/bar';
import { ResponsivePie } from '@nivo/pie';

// import LoaderIndex from "../../containers/LoaderIndex"

const TableFilters = (props) => {

    const [selectedFruit, setSelectedFruit] = useState('orange'); 

    const graphLegend = props.graphLegend;
    const regions = graphLegend?.regions ?? [];
    const wards = graphLegend?.wards ?? [];
    const districts = graphLegend?.districts ?? [];
    const parties = graphLegend?.parties ?? [];

    console.log('graphLegend: ', graphLegend);

    return (
        <div className="data-table-filters">
                {/* <select>
                    <option selected disabled aria-readonly>Slovensko</option>
                </select> */}
                <select
                    onChange={e => setSelectedFruit(e.target.value)}
                >                    
                    {regions.map((option) => {
                    return (                        
                        <option key={option.code} value={option.code}>
                        {option.name}
                        </option>
                    );
                    })}
                    <option selected disabled aria-readonly>Vyberte kraj</option>
                </select>

                <select
                    onChange={e => setSelectedFruit(e.target.value)}
                >                    
                    {wards.map((option) => {
                    return (                        
                        <option key={option.code} value={option.code}>
                        {option.name}
                        </option>
                    );
                    })}
                    <option selected disabled aria-readonly>Vyberte obvod</option>
                </select>

                <select
                    onChange={e => setSelectedFruit(e.target.value)}
                >                    
                    {districts.map((option) => {
                    return (                        
                        <option key={option.code} value={option.code}>
                        {option.name}
                        </option>
                    );
                    })}
                    <option selected disabled aria-readonly>Vyberte okres</option>
                </select>
                </div>
    )
}

export default TableFilters;